const OmbudsmanStatus = {
  NEW: 0,
  PROCESSING: 1,
  CONCLUDED: 2,
};

export default OmbudsmanStatus;
